/*
 * @Description:
 * @Date: 2024-05-17 14:35:55
 */
import request from '@/tools/request';

const baseUrl = '/rest/cso/saas';

// 客户列表，如无数据则不展示客户菜单
export const pageList = data => {
  return request.post(`${baseUrl}/crmCustomer/pageList`, data);
};
